import React from "react"
import Slider from "react-slick"
import Svg from "../_svgs/svg"
import CountUp from "react-countup"
import { getFromSelectionFactory } from "../helpers/SelectionFactoryHelper"
import VisibilitySensor from "react-visibility-sensor"
import { generateRandomString } from "../../helpers/keys"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function NumberCardsContainer({ numberCards, lang }) {
  const windowWidth = useWindowWidth()

  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "5%",
        },
      },
    ],
  }

  const htmlNumberCards =
    numberCards.length > 0
      ? numberCards.map((card) => {
          return (
            <NumberCard
              key={generateRandomString()}
              icon={card.icon[0] || null}
              number={card.precisionNumber}
              description={card.description}
              displayPercent={card.displayPercent}
              displayMillions={card.displayMillions}
              additionalPrefixes={card.additionalPrefixes}
              additionalSuffixes={card.additionalSuffixes}
              lang={lang}
            />
          )
        })
      : null

  return (
    <section className="number-cards-container">
      <div className={`${!!htmlNumberCards && htmlNumberCards.length === 4 ? "w--wider" : "w--normal"}`}>
        <div className="flex">{windowWidth >= 1024 ? htmlNumberCards : <Slider {...settings}>{htmlNumberCards}</Slider>}</div>
      </div>
    </section>
  )
}

export function NumberCard({ icon, number, description, displayPercent, displayMillions, lang, additionalPrefixes, additionalSuffixes }) {
  const svg = icon?.value || undefined
  let hasDecimal = false

  if (number) hasDecimal = number % 1 !== 0 ? true : false

  let suffix = displayMillions ? " mio" : ""
  suffix += displayPercent ? "%" : ""

  const additionalSuffix = getFromSelectionFactory(additionalSuffixes, false)
  const additionalPrefix = getFromSelectionFactory(additionalPrefixes, false)

  let prefix = additionalPrefix
  suffix = suffix || additionalSuffix

  let decimal = lang === "da" ? "," : "."
  let seperator = lang === "da" ? "." : ","
  //' Years' is a constant value from epi.
  //Reason for this implementation is so epi writers wouldnt have to annotate in both english & danish for culture specificity reasons.
  suffix = suffix === " Years" && lang === "da" ? " År" : suffix

  return (
    <div data-epi-property="" className="card-container">
      <article className="number-card">
        {svg ? <Svg iconName={svg} fillColor={"transparent"} stroke={"#000"} key={svg}></Svg> : ""}
        <VisibilitySensor partialVisibility offset={{ bottom: 50 }}>
          {({ isVisible }) => (
            <div data-epi-property="Number" aria-hidden="true" className="counter">
              {/* https://github.com/glennreyes/react-countup/blob/master/LICENSE */}
              {isVisible ? (
                <CountUp
                  start={0}
                  end={number}
                  duration={3}
                  prefix={prefix}
                  suffix={suffix}
                  decimal={decimal}
                  decimals={hasDecimal ? 1 : 0}
                  separator={seperator}
                />
              ) : null}
            </div>
          )}
        </VisibilitySensor>
        <p data-epi-property="Description" className="infotext">
          {description}
        </p>
      </article>
    </div>
  )
}
